import { Space, Typography } from 'antd'
import { MdOutlineAttachFile } from 'react-icons/md'

const { Text } = Typography

/** Файл так, як його віддає запис (`file:short:read`). */
interface FileLike {
    uuid?: string
    originalName?: string | null
    url?: string | null
}

const filesOf = (value: unknown): FileLike[] =>
    (Array.isArray(value) ? value : value !== null && typeof value === 'object' ? [value] : []).filter(
        (file): file is FileLike => file !== null && typeof file === 'object'
    )

/**
 * Файли запису в клітинці таблиці: назва — посилання, прочерк — коли файлу
 * немає.
 *
 * Посилання — підписане, з терміном дії (ADR 042, `SPEC-008` §5.7.5), і
 * відкривається в новій вкладці, щоб не закривати картку. Клік не відкриває
 * картку рядка.
 */
export const CrmFileLinks = ({ value }: { value: unknown }) => {
    const files = filesOf(value)

    if (files.length === 0) return <Text type="secondary">—</Text>

    return (
        <Space direction="vertical" size={2} onClick={(event) => event.stopPropagation()}>
            {files.map((file, index) => (
                <Space key={file.uuid ?? index} size={4}>
                    <MdOutlineAttachFile />
                    {file.url ? (
                        <a href={file.url} target="_blank" rel="noreferrer">
                            {file.originalName ?? 'файл'}
                        </a>
                    ) : (
                        (file.originalName ?? 'файл')
                    )}
                </Space>
            ))}
        </Space>
    )
}
